import _ from 'lodash'
import { typeList } from '../../api'
import { list as typeGroupList } from '@/apps/crm/contacts/api/groups'
import {
  list as typeParamsList,
  listAll as listContactTypes
} from '@/apps/crm/contacts/api/types/index'
import { listAll as listAllParemeters } from '@/apps/crm/contacts/api/parameters'
// Идентификаторы сущностей для массовой загрузки
let _types_ids = []

const loadTypes = commit => {
  _types_ids = []
  typeList().then(data => {
    commit('setTypes', data.list)
  })
}

// Гарантированный вызов 'loadEntities' раз в секунду с устранением дребезга
const debouncedLoadTypes = _.debounce(loadTypes, 250, { maxWait: 1000 })

export default {
  loadTypes: ({ commit }, id) => {
    _types_ids.push(id)
    debouncedLoadTypes(commit)
  },
  getTypeGroups({ commit }, id) {
    return typeGroupList(id).then(data => {
      commit('setTypeGroups', { id, groups: data.list })
      return data
    })
  },
  getTypeParams({ commit }, id) {
    typeParamsList(id).then(params => {
      commit('setTypeParams', { id, params: params })
    })
  },
  loadTypeGroups({ commit }, id) {
    return typeGroupList(id).then(data => {
      commit('setTypeGroups', { id, groups: data.list })
      return data.list
    })
  },
  loadTypeParams({ commit }, id) {
    return typeParamsList(id).then(params => {
      commit('setTypeParams', { id, params: params })
      return params
    })
  },
  // Load all contact types with groups and bindings
  loadContactTypes({ state, commit }, force = false) {
    if (state.contactTypes !== false && !force) {
      return Promise.resolve(state.contactTypes)
    }
    return listContactTypes().then(types => {
      commit('SET_CONTACT_TYPES', types)
      return types
    })
  },
  // Load all contact attributes
  loadAttributes({ state, commit }, force = false) {
    if (state.attributes !== false && !force) {
      return Promise.resolve(state.attributes)
    }
    return listAllParemeters().then(attributes => {
      commit('SET_ATTRIBUTES', attributes)
      return attributes
    })
  }
}



// WEBPACK FOOTER //
// ./src/apps/crm/contacts/store/common/actions.js